// extracted by mini-css-extract-plugin
export var headerWrap = "business-module--headerWrap--174b6";
export var swiperWrap = "business-module--swiperWrap--3A_EK";
export var partnersWrap = "business-module--partnersWrap--37vrk";